const convertHexToRGB = hex => {
  if (typeof hex !== 'string') {
    console.log('Invalid hex value');
    return false;
  }
  let color = hex.replace('#', '');
  let rgb;
  if (color.length === 3) {
    const shorthandRegex = /^([a-f\d])([a-f\d])([a-f\d])$/i;
    color = hex.replace(shorthandRegex, (m, r, g, b) => [r, r, g, g, b, b].join(''));
  }
  if (color.length === 6) {
    rgb = color.match(/.{2}/g);
    return rgb.map(c => parseInt(c, 16)).join(',');
  } else {
    console.info('Cannot convert invalid hex color');
    return false;
  }
};
export const rgb = hex => "rgb(".concat(convertHexToRGB(hex), ")");
export const rgba = (hex, opacity) => "rgba(".concat(convertHexToRGB(hex), ",").concat(opacity, ")");
//# sourceMappingURL=convertHexToRgb.js.map